export const MODULE = {
    SELF_BANNER: 'self-banner', // 基本信息
    EASILY_READ: 'easily-read', // 财报轻松读
    SKIMMING_OPERATING_DATA: 'skimming-operating-data', // 财报速览，经营数据
    ENT_SAY: 'ent-say', // 企业说财报
    QA: 'qa', // 企业问答
    INTERPRETATION: 'interpretation', // 财报解读
    ANALYST_RATING: 'analyst-rating', // 分析师评级图表
    ANALYST_RATING_CHART_NEWS: 'analyst-rating-chart-news', // 分析师评级图表+资讯
    NEWS: 'news'
};

export const MODULE_OPTIONS = [
    {
        label: '个股信息',
        value: MODULE.SELF_BANNER
    }, // 基本信息
    {
        label: '财报速览-营收概览',
        value: MODULE.EASILY_READ
    },
    {
        label: '财报速览-经营数据',
        value: MODULE.SKIMMING_OPERATING_DATA
    },
    {
        label: '企业说财报',
        value: MODULE.ENT_SAY
    }, // 企业说财报
    {
        label: '企业问答',
        value: MODULE.QA
    }, // 企业问答
    {
        label: '大咖观点', // 分析解读改为大咖观点
        value: MODULE.INTERPRETATION
    }, // 财报解读
    {
        label: '分析师评级-图表',
        value: MODULE.ANALYST_RATING
    },
    {
        label: '分析师评级-图表+资讯',
        value: MODULE.ANALYST_RATING_CHART_NEWS
    },
    {
        label: '新闻资讯',
        value: MODULE.NEWS
    }
];

export const SKIN = {
    WHITE: 'white',
    BLACK: 'black'
};

export const SKIN_OPTIONS = [
    {
        label: '白色',
        value: SKIN.WHITE
    },
    {
        label: '黑色',
        value: SKIN.BLACK
    }
];

export const SKIN_NUM = {
    [SKIN.WHITE]: 0,
    [SKIN.BLACK]: 3
};

// 行情涨跌色
export const STOCK_COLOR_SETTING = {
    RED_UP_GREEN_DOWN: 0, // 红涨绿跌
    GREEN_UP_RED_DOWN: 1, // 绿涨红跌
    PINK_UP_GREEN_DOWN: 2, // 粉涨绿跌
    GREEN_UP_PINK_DOWN: 3 // 绿涨粉跌
};

// 行情涨跌色 OPTIONS
export const STOCK_COLOR_SETTING_OPTIONS = [
    {
        label: '红涨绿跌',
        value: STOCK_COLOR_SETTING.RED_UP_GREEN_DOWN
    },
    {
        label: '绿涨红跌',
        value: STOCK_COLOR_SETTING.GREEN_UP_RED_DOWN
    },
    {
        label: '粉涨绿跌',
        value: STOCK_COLOR_SETTING.PINK_UP_GREEN_DOWN
    },
    {
        label: '绿涨粉跌',
        value: STOCK_COLOR_SETTING.GREEN_UP_PINK_DOWN
    }
];

/* eslint-disable no-multi-spaces */
// 配置类型
export const CATEGORY = {
    ANNOUNCE: 'announce',           // 预告
    LIVE: 'live',                   // 直播
    FEED: 'feed',                   // feed
    COMMUNITY: 'community',         // 社区
    NEWS: 'news',                   // 资讯
    VIDEOS: 'videos',               // 视频
    DISCUSSION: 'discussion',       // 讨论
    HIGHLIGHT: 'highlight',         // 纪要
};

// 用这个来判断内容的类型
export const CONTENT_CATEGORY = {
    FEED: 1, // 普通帖子
    VIDEO_FEED: 2, // 视频帖子
    DISCUSSION: 3, // 社区话题
    NEWS: 4, // 资讯
    LIVE: 5, // 直播
    ANNOUNCE: 6 // 直播预告
};


// 预告状态
export const ANNOUNCE_STATUS = {
    UNSUBSCRIBED: 1,                // 文案：预约。 直播未开始，自己未预约，未到预播时间
    SUBSCRIBED: 2,                  // 文案：已预约。 直播未开始，自己已预约，未到预播时间
    WAITING_START: 3,               // 文案：等待开始。直播未开始，与自己是否预约无关，已到预播时间
    ON_LIVING: 4,                   // 文案：去围观。直播已开始，与自己是否预约无关，与预播时间无关
    ENDED_WITHOUT_RECORDING: 5,     // 文案：已结束。直播已结束无录播，与自己是否预约无关，与预播时间无关
    ENDED_WITH_RECORDING: 6,        // 文案：去回看。直播已结束有录播，与自己是否预约无关，与预播时间无关
    NOT_AVAILABLE: 7                // 文案：已过期。自己未预约，直播没有在预告时间内开始
};

// 直播状态
export const FEED_LIVE_STATUS = {
    ON_LIVING: 0,                   // 直播中
    ON_TRANSCODING: 1,              // 转录播中
    END_WITHOUT_TRANSCODE: 2,       // 已结束，不需要转录播
    TRANSCODE_SUCCESS: 3            // 转录播成功
};

// 明星企业广场 - 排序
export const ORDER_BY = {
    TIME: 1,
    REVENUE: 2,
    ROE: 3,
    NET_INCOME: 4
};

export const ORDER_BY_MAP = {
    [ORDER_BY.TIME]: '最新',
    [ORDER_BY.REVENUE]: '营收',
    [ORDER_BY.ROE]: 'ROE',
    [ORDER_BY.NET_INCOME]: '净利润',
};

// 涨跌
export const RISE = 'rise'; // 涨
export const FALL = 'fall'; // 跌

// 季度
export const SEASONS = {
    'Q1': 1,
    'Q2': 2,
    'Q3': 3,
    'Q4': 4,
    'H1': 5,
    'H2': 6,
    'Q6': 7,
    'Q9': 8,
    'Annual': 9,
};

// 个股数据类型
export const STOCK_DATE_CATEGORY = {
    ROE: 'roe',
    NET_INCOME: 'net_income', // 净利润
    REVENUE: 'ent_gain' // 营收
};

// 文章标签
export const ARTICLE_LABEL = {
    'preview': '前瞻',
    'explain': '解读',
    'comment': '点评'
};

// 业绩会发布前or中or后or无
export const CALL_STATUS_TYPE = {
    BEFORE: 'before',
    BETWEEN: 'between',
    AFTER: 'after',
    NONE: 'none'
};

export const MEETING_STATUS_TYPE = CALL_STATUS_TYPE;

// 话题关联的feedlist类型
export const DISCUSSION_FEED_LIST_TYPE = {
    HOT: 4, // 热门
};

// 数值单位
export const UNIT_MAP = {
    NONE: '',
    PERCENT: '%',
    T_T: '万',
    H_M: '亿',
    TRILLION: '万亿',
    K: 'K',
    M: 'M',
    B: 'B',
    T: 'T'
};

// 数值单位换算值
export const UNIT_VAL_MAP = {
    [UNIT_MAP.T_T]: 10000,
    [UNIT_MAP.H_M]: 100000000,
    [UNIT_MAP.TRILLION]: 1000000000000,
    [UNIT_MAP.K]: 1000,
    [UNIT_MAP.M]: 1000000,
    [UNIT_MAP.B]: 1000000000,
    [UNIT_MAP.T]: 1000000000000,
};

export const ENT_ANALYSIS_HIGHLIGHT_TYPE = {
    ONE_PIC: 1, // 1图读懂财报
    VIDEO: 2,  // 财报小视频
    OTHER: 3, // 其他
};

export const ENT_ANAlYSIS_MEETING_TYPE = {
    LIVE: 1, // 直播
    ANNOUNCE: 2, // 预告
    NOTE: 3 // 纪要
};

export const FINANCIAL_REPORT_ERROR_CODE = {
    REGION_NOT_ALLOW: 110008,
    PAGE_NOT_FOUND: 110009
};

